import React from "react";
import { LexicalProps } from "../LexicalEditor.types";
import { SelectAllIcon } from "../../../assets/icons/SvgIcons";

const SelectAll = ({ editor, isDropdown }: LexicalProps) => {
  const selectAllContent = () => {
    editor.update(() => {
      const root = editor.getRootElement();
      if (root) {
        const range = new Range();
        range.selectNodeContents(root);

        const selection = window.getSelection();
        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    });
  };

  return (
    <div
      onClick={selectAllContent}
      className={`lexical-toolbarItem ${
        isDropdown ? "lexical-dropdownItem" : ""
      }`}
    >
      <div className="lexical-shortcutWrapper">
        <SelectAllIcon />
        <span className="lexical-shortcutText">Select all</span>
      </div>
      <span className="lexical-shortcut">Ctrl+A</span>
    </div>
  );
};

export default SelectAll;
